import { EMAIL_PRIVATE_TYPE } from '../Email.constants'

export function isPublicOption(option) {
  return !option[EMAIL_PRIVATE_TYPE]
}
